import type { CSSProperties } from 'react';
import { useState } from 'react';
import styled from 'styled-components';

import { fadeIn } from '#src/atoms/animations/keyframes.ts';
import { Carousel } from '#src/atoms/navigation/Carousel/index.tsx';

type Img = {
  src: string;
  alt: string;
  className?: string;
};

const CarouselContainer = styled.div`
  margin: auto;
`;

const Img = styled.img`
  aspect-ratio: var(--card-aspect-ratio);
  max-width: var(--slotSize);

  opacity: 1;

  &.fadeOut {
    opacity: 0;
    animation: 0.8s ${fadeIn} ease reverse;
  }
`;

const ImgContainer = styled.div`
  position: relative;
  &:after {
    content: '';
    width: 100%;
    left: 0;
    position: absolute;
    top: 100%;
    box-shadow: 0px 0px 27px 4px rgba(0, 0, 0, 0.67);
  }
`;

type Props = {
  cards: Img[];
  defaultActiveCard?: number;
  slotSize?: number;
};

export const CardsCarousel = ({
  cards,
  defaultActiveCard,
  slotSize = 200,
}: Props) => {
  const [index, setIndex] = useState(
    defaultActiveCard || Math.floor(cards.length / 2)
  );

  return (
    <CarouselContainer>
      <Carousel
        elements={cards}
        renderElement={card => {
          return (
            <ImgContainer key={card.alt}>
              <Img
                loading="lazy"
                src={card.src}
                alt={card.alt}
                className={card.className}
              />
            </ImgContainer>
          );
        }}
        selectedIndex={index}
        setSelectedIndex={setIndex}
        onClick={(_, i) => setIndex(i)}
        style={
          {
            '--slotSize': `${slotSize}px`,
          } as CSSProperties
        }
      />
    </CarouselContainer>
  );
};
